var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_4192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.293751 9.29414C-0.0968742 9.68477 -0.0968742 10.3191 0.293751 10.7098L5.29375 15.7098C5.68438 16.1004 6.31875 16.1004 6.70938 15.7098C7.1 15.3191 7.1 14.6848 6.70938 14.2941L3.4125 11.0004H13C13.5531 11.0004 14 10.5535 14 10.0004C14 9.44727 13.5531 9.00039 13 9.00039H3.41563L6.70625 5.70664C7.09688 5.31602 7.09688 4.68164 6.70625 4.29102C6.31563 3.90039 5.68125 3.90039 5.29063 4.29102L0.290626 9.29102L0.293751 9.29414Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_4192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2H14V18H0V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.1d2b5377e812fc4e9fc881d6139a1ff9.svg";
export { ForwardRef as ReactComponent };